module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("doOh5"))).then(() => parcelRequire('d0iPb'));